import styled from "styled-components";
import {LanguageSwitcherItemLabelDefaultBox} from "./language-switcher-item-label.default.box";

export const LanguageSwitcherItemLabelMrGreenBox = styled(LanguageSwitcherItemLabelDefaultBox)`
    color: ${props => props.isSelected ? props.theme.colors.textActive : props.theme.colors.text};
`;
